<div class="preview-modal">
  <div class="preview-header">
    <h2>{{ data.titulo }}</h2>
    <button mat-icon-button type="button" aria-label="Cerrar" (click)="cerrar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="preview-body">
    <iframe
      class="preview-frame"
      [src]="pdfUrlSeguro"
      title="Previsualización de cotización">
    </iframe>
  </div>

  <div class="preview-footer">
    <button *ngIf="!data.esColectivo" type="button" class="btn-footer btn-enviar" (click)="enviar()">ENVIAR</button>
    <button type="button" class="btn-footer btn-descargar" (click)="descargar()">DESCARGAR PDF</button>
    <button type="button" class="btn-footer btn-cancelar" (click)="cerrar()">CANCELAR</button>
  </div>
</div>
